import {
  AccountCircle,
  CalendarMonth,
  Home,
  Message
} from "@mui/icons-material";
import { ReactNode } from "react";

import GridViewSharpIcon from '@mui/icons-material/GridViewSharp';
import GroupsIcon from '@mui/icons-material/Groups';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import BookingIcon from "assets/icons/bookings_referral_icons.svg";
import BusinessListIcon from "assets/icons/business_list.svg";
import IntegrationIcon from "assets/icons/Integration.svg";
import SettingIcon from "assets/icons/setting.svg";
import StripeIcon from "assets/icons/stripe.svg";

export interface SideNavItem {
  title: string;
  path: string;
  icon: ReactNode | (() => JSX.Element);
  children?: SideNavItem[];
}

export const sideNavConfig: SideNavItem[] = [
  {
    title: "Home",
    path: "/home",
    icon: <Home />,
  },
  {
    title: "Profile",
    path: "/profile",
    icon: <AccountCircle />,
  },
  {
    title: "Items",
    path: "/my-items",
    icon: <GridViewSharpIcon />,
  },
  {
    title: "Availabilities",
    path: "/my-availabilities",
    icon: <CalendarMonth />,
  },
  {
    title: "Bookings & Referrals",
    path: "/bookings",
    icon: () => (
      <img src={BookingIcon} width={22} height={22} alt="booking-icon" />
    ),
  },
  {
    title: "Referrals",
    path: "/bookings",
    icon: () => (
      <img src={BookingIcon} width={22} height={22} alt="booking-icon" />
    ),
  },
  {
    title: "Referee Network",
    path: "/referees",
    icon: <GroupsIcon />,
  },
  {
    title: "Messages",
    path: "/chat",
    icon: <Message />,
  },
  {
    title: "Share Multiple Businesses",
    path: "/businesslist",
    icon: () => (
      <img src={BusinessListIcon} width={24} height={24} alt="business-list" />
    ),
  },
  // {
  //   title: "QR Lists",
  //   path: "/qrlist",
  //   icon: () => <img src={QRIcon} width={24} height={24} alt="qr-list" />,
  // },
  //comment for future  use.

  {
    title: "Reports",
    path: "/reports/:id",
    icon: () => (
      <SummarizeOutlinedIcon sx={{ width: 24, height: 24 }} />
    ),
  },

  {
    title: "Settings",
    path: "/settings",
    icon: () => <img src={SettingIcon} width={22} height={22} alt="setting" />,
    children: [
      {
        title: "Account",
        path: "/profile",
        icon: <AccountCircle />,
      },
      {
        title: "Integration",
        path: "/settings/integration",
        icon: () => (
          <img src={IntegrationIcon} width={24} height={24} alt="integration" />
        ),
      },
      {
        title: "Payout",
        path: "/settings/payout",
        icon: () => (
          <img src={StripeIcon} width={20} height={20} alt="stripe" />
        ),
      },
    ],
  },
];
